<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
    :persistent="true"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}
          <v-chip
            v-show="form.Status"
            small
          >{{ form.Status }}</v-chip>
        </span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text ref="cardContent">
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <!-- <v-autocomplete
                  clearable
                  :items="projects"
                  item-text="Name"
                  item-value="ID"
                  label="專案"
                  v-model="form.ProjectID"
                ></v-autocomplete> -->
                <v-autocomplete
                  clearable
                  :items="clientList"
                  :item-text="clientSelectLabel"
                  item-value="ID"
                  label="客戶"
                  v-model="form.ClientID"
                ></v-autocomplete>
                <!-- <v-autocomplete
                  clearable
                  :items="departments"
                  item-text="Name"
                  item-value="ID"
                  label="部門"
                  v-model="form.DepartmentID"
                ></v-autocomplete> -->
                <v-autocomplete
                  clearable
                  :items="userOptions"
                  item-text="Name"
                  item-value="ID"
                  label="人員"
                  v-model="form.UserID"
                ></v-autocomplete>

                <!-- <v-menu
                  v-model="isShowDateMenu"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.Date"
                      clearable
                      label="日期"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.Date"
                    @change="isShowDateMenu = false"
                  ></v-date-picker>
                </v-menu> -->
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="primary darken-1"
          depressed
          outlined
          text
          @click="submit"
        >確認</v-btn>
      </v-card-actions>
    </v-card>

    <!-- <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay> -->

  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  mixins: [filterMixin],
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    filterCondition: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {},
    defaultForm: {
      ProjectID: 0,
      DepartmentID: 0,
      UserID: 0
    },
    isShowDateMenu: false
  }),
  computed: {
    formTitle() {
      return "專案篩選條件";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    userOptions() {
      return this.activeUsers.filter(o=>{
        return AppDataSetting.findUserLevel(this, o) <= 10
      }).map(o => {
        return { ID: o.ID, Name: o.Profile.Name };
      });
    },
    clientList() {
      if (this.form.ClientID > 0) {
        var idx = this.activeClientList.findIndex(
          o => o.ID === this.form.ClientID
        );
        if (idx < 0) {
          var inactiveClient = this.$store.state.client.list.find(
            o => o.ID === this.form.ClientID
          );
          if (inactiveClient) {
            return [inactiveClient].concat(this.activeClientList);
          }
        }
      }
      return this.activeClientList;
    },
    ...mapGetters([
      "me",
      "myLevel",
      "projects",
      "departments",
      "users",
      "taskWorkingItems",
      "activeUsers",
      "userPositions",
      "activeClientList",
      "countries"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    submit() {
      this.$emit('updated', this.form)
      this.isShowDialog = false;
    },
    resetForm() {
      if (!this.value) return;
      if (this.$refs.cardContent) {
        this.$nextTick(() => this.$refs.cardContent.scrollTo(0, 0));
      }
      this.form = JSON.parse(
        JSON.stringify(this.filterCondition)
      );
    },
    clientSelectLabel(client) {
      let clientCountyName = (
        this.countries.find(o => o.ID === client.CountyID) || {}
      ).Name;
      return (clientCountyName || "") + client.Name;
    },
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.taskWorkingItem.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>